export const meta = {
  title: '联系 CADCraft AI',
  description: '联系 CADCraft AI 社区指南站，反馈问题、勘误和内容建议。',
  updated_at: '2026-10-15',
};

## 邮件联系

联系本站的主要方式是发送邮件至 [support@cadcraft.org](mailto:support@cadcraft.org)。你可以通过这个邮箱咨询指南内容、失效链接、翻译问题、无障碍访问、隐私事项，或建议我们撰写新的主题。

我们通常会在 **2—3 个工作日内**回复。需要核对版本、复现命令，或比较文件格式行为的问题，处理时间可能更长。如果是跟进已有邮件，请直接回复原邮件线程，以便保留上下文。

为了方便排查技术问题，请尽量附上 CADCraft 版本、操作系统、输入文件类型、完整命令或操作步骤，以及错误信息。小型可复现图纸或截图也会有帮助，但发送前请删除项目中的私人或保密信息。

CADCraft AI 是独立的指南站，不是 CADCraft 官方项目，也不是 Autodesk, Inc. 或 ArtCraft 团队的支持渠道。我们可以修正本站内容并指向官方项目资料，但不能保证代表这些组织提供软件修复或官方答复。
